import ContentLayout from '@/components/content/ContentLayout'
import ContentList from '@/components/content/ContentList'
import ContentListBoss from '@/components/content/ContentListBoss'
import ContentDetailBoss from '@/components/content/ContentDetailBoss'
import ContentCreate from '@/components/content/ContentCreate'
import ContentTemplateCreate from '@/components/content/ContentTemplateCreate'
import ContentEdit from '@/components/content/ContentEdit'
import ContentStatistic from '@/components/content/ContentStatistic'
import ContentStatisticTemplate from '@/components/content/ContentStatisticTemplate'
import HelpStatistic from '@/components/content/HelpStatistic'
import EmployeeData from '@/components/content/EmployeeData'
import ContentCustomer from '@/components/content/ContentCustomer'
import ContentCustomerTemplate from '@/components/content/ContentCustomerTemplate'
import ContentView from '@/components/content/ContentView'

export default {
  path: 'content',
  component: ContentLayout,
  children: [{
    name: 'contentList',
    path: 'contentList',
    component: ContentList,
    meta: {
      module: 'content',
      keepAlive: true,
      isOutside: false,
      isPreserve: false,
    },
  }, {
    name: 'contentListBoss',
    path: 'contentListBoss',
    component: ContentListBoss,
    meta: {
      module: 'content',
      keepAlive: true,
      isOutside: false,
      isPreserve: false,
    },
  }, {
    name: 'contentCreate',
    path: 'contentList/contentCreate',
    component: ContentCreate,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'contentTemplateCreate',
    path: 'contentList/contentTemplateCreate',
    component: ContentTemplateCreate,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'contentEdit',
    path: 'contentList/contentEdit',
    component: ContentEdit,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'contentStatistic',
    path: 'contentList/contentStatistic',
    component: ContentStatistic,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  },
  {
    name: 'contentStatisticTemplate',
    path: 'contentList/contentStatisticTemplate',
    component: ContentStatisticTemplate,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'helpStatistic',
    path: 'contentList/helpStatistic',
    component: HelpStatistic,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'employeeData',
    path: 'contentList/employeeData',
    component: EmployeeData,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'contentCustomer',
    path: 'contentList/contentCustomer',
    component: ContentCustomer,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'contentCustomerTemplate',
    path: 'contentList/contentCustomerTemplate',
    component: ContentCustomerTemplate,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'contentView',
    path: 'contentList/contentView',
    component: ContentView,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    name: 'contentDetailBoss',
    path: 'contentListBoss/contentDetailBoss',
    component: ContentDetailBoss,
    meta: {
      module: 'content',
      isSlibing: true,
    },
  }, {
    path: '/',
    redirect: { name: 'contentList' },
  }],
}



// WEBPACK FOOTER //
// ./src/router/Content.js